// Growth for the per-frame rebuilt render batches (GlyphLayer, HealthBars, LineBatch). Each starts at its war's
// presized capacity (match/warSetup.ts) and doubles when a frame outgrows it, so an army past the presize (an unlimited
// body cap) never overflows a buffer. Growth allocates; a steady frame never does.

import { BufferAttribute, DynamicDrawUsage, InstancedBufferAttribute } from 'three'

const GROWTH_FACTOR = 2

/** The smallest doubling of `capacity` that holds `needed` items. */
export function grownCapacity(capacity: number, needed: number): number {
  let next = Math.max(1, capacity)
  while (next < needed) next *= GROWTH_FACTOR
  return next
}

/** A zeroed array of `length` floats holding the first `keep` floats of `source`. */
function grownArray(source: BufferAttribute, length: number, keep: number): Float32Array {
  const array = new Float32Array(length)
  array.set((source.array as Float32Array).subarray(0, keep))
  return array
}

/** A dynamic per-instance attribute like `attribute`, sized for `capacity` instances, keeping its first `used`. */
export function grownInstanced(attribute: InstancedBufferAttribute, capacity: number, used: number): InstancedBufferAttribute {
  const size = attribute.itemSize
  return new InstancedBufferAttribute(grownArray(attribute, capacity * size, used * size), size).setUsage(DynamicDrawUsage)
}

/** A dynamic vertex attribute like `attribute`, sized for `vertices` vertices, keeping its first `used`. */
export function grownVertices(attribute: BufferAttribute, vertices: number, used: number): BufferAttribute {
  const size = attribute.itemSize
  return new BufferAttribute(grownArray(attribute, vertices * size, used * size), size).setUsage(DynamicDrawUsage)
}
